import {Injectable} from '@angular/core';
import {FILTERS_CONFIG} from './filtersConfig';
import {Filter} from './filter';
import {HistoricalValuePresentationDTO} from '../../../api';

@Injectable()
export class FiltersService {

  private GAS = 'gas';
  private ELECTRICITY = 'electricity';

  private VISIBLE_NUMBER_OF_YEARS = 2;

  constructor() {
  }

  public initFiltersForProductType(productTypeName: string) {
    switch (productTypeName) {
      case this.GAS:
        return this.initFiltersForGas();
      case this.ELECTRICITY:
        return this.initFiltersForElectricity();
    }
  }

  private initFiltersForGas() {
    const filters = FILTERS_CONFIG.gas;
    this.setCheckedYearFilters(filters.years);
    return filters;
  }

  private initFiltersForElectricity() {
    const filters = FILTERS_CONFIG.electricity;
    this.setCheckedYearFilters(filters.years);
    return filters;
  }

  private setCheckedYearFilters(years: Filter[]) {
    // years.forEach((filter: Filter) => {
    //   filter.checked = filter.filter > moment().year().toString() &&
    //     filter.filter <= (moment().year() + this.VISIBLE_NUMBER_OF_YEARS).toString();
    // });
  }

  public initYearsFilters(historicalValues: HistoricalValuePresentationDTO[]): Filter[] {
    const yearFilters = this.extractAllYearsAsFilters(historicalValues);
    this.sortFiltersByIndex(yearFilters);
    this.setCheckedYearFilters(yearFilters);
    return yearFilters;
  }

  private extractAllYearsAsFilters(historicalValues: HistoricalValuePresentationDTO[]) {
    const years: Set<number> = new Set();
    historicalValues.forEach((historicalValue: HistoricalValuePresentationDTO) => {
      years.add(historicalValue.productYear);
    });
    const yearFilters: Filter[] = [];
    years.forEach((year: number, index: number) => {
      yearFilters.push(new Filter(year.toString(), false, index));
    });
    return yearFilters;
  }

  private sortFiltersByIndex(filters: Filter[]) {
    filters.sort((current: Filter, next: Filter) => (current.index > next.index) ? 1 : ((next.index > current.index) ? -1 : 0));
  }
}
